import React from "react";
import { UserOutlined } from "@ant-design/icons"
import { Avatar } from "antd"
import "./index.css"

const HeaderComponent = ({ logo, name }) => (
    <div type="space-between" className="merchant-details">
        <div className="merchant-logo" >
            <Avatar
                src={logo} shape="square" style={{ width: "50px", height: "50px", borderRadius: "10px", display: "flex", alignItems: 'center', justifyContent: 'center' }}
                icon={<UserOutlined />}
            >
            </Avatar>
        </div>
        <div className="merchant-name" span={21}>
            <p style={{ fontSize: "20px" }}>{name}</p>
        </div>
    </div>
)

export default HeaderComponent